import { useMutation } from 'react-query'
import request from '../request'

export const useEditUser = () => {
  return useMutation(
    ({ user_id, data }: { user_id: number; data: Record<string, string | number> }) => {
      return request({
        url: `/auth/user/${user_id}`,
        method: 'PATCH',
        data,
      })
    },
  )
}
